export default "__VITE_ASSET__BKq8JLPm__"